import api from "../config/api";

export const fetchAllDropdown = async () => {
  const res = await api.get("/dropdownMaster/");
  return res.data.data;
};

export const fetchDropdownById = (id) => {
    const res = api.get(`/dropdownMaster/?id=${id}`);
    return res.data.data;
};
export const fetchDropdownByCategoryWise = async(category) => {
    const res =await api.get(`/dropdownMaster/?category=${category}`);
    return res.data.data;
};

export const createDropdown = async (postData) => {
  const res = await api.post(`/dropdownMaster/`, postData);
  return res.data;
};

export const updateDropdown = async (commentId, postData) => {
  const res = await api.put(`/dropdownMaster/?id=${commentId}`, postData);
  return res.data;
};

export const deleteDropdown = async (commentId) => {
  const res = await api.delete(`/dropdownMaster/?id=${commentId}`);
  return res.data;
};
export const fetchDropdownByTitle = async (title) => {
  const res = await api.get(`/dropdownMaster/?title=${(title)}`);
  return res.data.data;
};





